/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

import validations from "customValidations/validations";
import validationService from "customValidations/validationService";

// Images
import bgImage from "assets/images/backgroundLogin.png";
import bgImageMobile from "assets/images/backgroundLoginMobile.png";
import singhCoinBrand from "assets/images/singhCoinBrand.png";

import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { signUp } from "services/userService";
import BasicLayout from "../components/BasicLayout";
import MDAvatar from "components/MDAvatar";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

function SignUpBusiness() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [website, setWebsite] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [errorMsg, setErrorMsg] = useState({
    userName: { errorMsg: "" },
    email: { errorMsg: "" },
    companyName: { errorMsg: "" },
    website: { errorMsg: "" },
    password: { errorMsg: "" },
    confirmPassword: { errorMsg: "" },
  });

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    checkIfLoggedIn();
  }, []);

  const checkIfLoggedIn = () => {
    if (localStorage.jwtTokenSingh) {
      navigate("/dashboard");
    }
  };

  const customValidations = (name, value) => {
    let errorLength = 0;
    const args = [
      {
        name,
        value: value,
        validations: validations.signUpValidations[name],
      },
    ];

    validationService.validate(args, (validationErr, validationErrMsgs) => {
      if (validationErrMsgs.length > 0) {
        errorLength = errorLength + 1;
        errorMsg[name].errorMsg = validationErrMsgs[0].validations[0].message;
        setErrorMsg({ ...errorMsg });
      } else {
        errorMsg[name].errorMsg = "";
        setErrorMsg({ ...errorMsg });
      }
    });
    return errorLength;
  };

  const handleShowPassword = () => setShowPassword(!showPassword);

  const handleInputChange = (name, value) => {
    if (name === "userName") {
      setUserName(value);
    } else if (name === "email") {
      setEmail(value);
    } else if (name === "companyName") {
      setCompanyName(value);
    } else if (name === "website") {
      setWebsite(value);
    } else if (name === "password") {
      setPassword(value);
    } else if (name === "confirmPassword") {
      setConfirmPassword(value);
    } else {
      console.log("IputError");
    }
  };

  const handleSignUp = async () => {
    let errorLengthUserName = customValidations("userName", userName);
    let errorLengthEmail = customValidations("email", email);
    let errorLengthCompanyName = customValidations("companyName", companyName);
    let errorLengthWebsite = customValidations("website", website);
    let errorLengthPassword = customValidations("password", password);
    let errorLengthConfirmPassword = customValidations(
      "confirmPassword",
      confirmPassword
    );

    if (
      errorLengthUserName !== 1 &&
      errorLengthEmail !== 1 &&
      errorLengthCompanyName !== 1 &&
      errorLengthWebsite !== 1 &&
      errorLengthPassword !== 1 &&
      errorLengthConfirmPassword !== 1
    ) {
      console.log("Alll okkkkkkk");
    } else {
      console.log("Validation error");
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire("", "Confirm Password doesn't match with password", "error");
      return;
    }

    const userData = {
      username: userName,
      email: email,
      companyName: companyName,
      website: website,
      password: password,
      confirmPassword: confirmPassword,
    };

    const signUpResponse = await signUp(userData);
    console.log("signUpRes", signUpResponse);
    // Swal.fire(
    //   "Great!",
    //   " You have successfully registered! \n Check your email for verification",
    //   "success"
    // );

    // if (signUpResponse.status === 200) {
    //   navigate("/");
    // }
  };

  return (
    <BasicLayout image={isDesktopOrLaptop ? bgImage : bgImageMobile}>
      <Card sx={{ backgroundColor: "#ebebeb", boxShadow: "none" }}>
        {/* <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MDAvatar src={singhCoinBrand} />
          </MDBox>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Join us today
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Register with Singh
          </MDTypography>
        </MDBox> */}
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            sx={{
              marginBottom: "2rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MDAvatar
              src={singhCoinBrand}
              sx={{ height: "100px", width: "100px" }}
            />
          </MDBox>
          <MDBox role="form">
            <MDBox mb={2}>
              <TextField
                fullWidth
                type="text"
                label="Username"
                name="userName"
                inputProps={{
                  style: { color: "#000000" },
                }}
                InputLabelProps={{ style: { color: "#6a6a6a" } }}
                value={userName}
                error={errorMsg.userName.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.userName.errorMsg}
              />
            </MDBox>
            <MDBox mb={2}>
              <TextField
                fullWidth
                label="Company Name"
                name="companyName"
                inputProps={{
                  style: { color: "#000000" },
                }}
                InputLabelProps={{ style: { color: "#6a6a6a" } }}
                value={companyName}
                error={errorMsg.companyName.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.companyName.errorMsg}
              />
            </MDBox>
            <MDBox mb={2}>
              <TextField
                fullWidth
                label="Website"
                name="website"
                inputProps={{
                  style: { color: "#000000" },
                }}
                InputLabelProps={{ style: { color: "#6a6a6a" } }}
                value={website}
                error={errorMsg.website.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.website.errorMsg}
              />
            </MDBox>
            <MDBox mb={2}>
              <TextField
                fullWidth
                label="Official Email"
                name="email"
                inputProps={{
                  style: { color: "#000000" },
                }}
                InputLabelProps={{ style: { color: "#6a6a6a" } }}
                value={email}
                error={errorMsg.email.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.email.errorMsg}
              />
            </MDBox>
            <MDBox mb={2}>
              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                label="Password"
                name="password"
                inputProps={{
                  style: { color: "#000000" },
                }}
                InputLabelProps={{ style: { color: "#6a6a6a" } }}
                value={password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => handleShowPassword()}>
                        {showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={errorMsg.password.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.password.errorMsg}
              />
            </MDBox>
            <MDBox mb={2}>
              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                label="Confirm Password"
                name="confirmPassword"
                value={confirmPassword}
                inputProps={{
                  style: { color: "#000000" },
                }}
                InputLabelProps={{ style: { color: "#6a6a6a" } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => handleShowPassword()}>
                        {showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={errorMsg.confirmPassword.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.confirmPassword.errorMsg}
              />
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Checkbox />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;I agree the&nbsp;
              </MDTypography>
              <MDTypography
                component="a"
                href="#"
                variant="button"
                fontWeight="bold"
                color="singh"
                // textGradient
              >
                Terms and Conditions
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton color="singh" fullWidth onClick={() => handleSignUp()}>
                sign Up
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Already have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/sign-in"
                  variant="button"
                  color="singh"
                  fontWeight="medium"
                  // textGradient
                >
                  Sign In
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default SignUpBusiness;
